import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/close_icon.png'
import _imports_1 from '@/assets/common/pwa_update_banner.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { style: {"padding":"0 20px"} }
const _hoisted_3 = { class: "detailsBg" }
const _hoisted_4 = { class: "infoText" }

import { ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '../../profile/contactServicePopup.vue';
import { useUserStore } from '@/stores/user';

export default /*@__PURE__*/_defineComponent({
  __name: 'pwaStatusPopup',
  setup(__props, { expose: __expose }) {

const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()

const open = (value: string) => {
    show.value = true
    title.value = value
}


const close = () => {
    show.value = false
    contactRef.value.close()
    userStore.setPwaShowing(false)
}


__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      onClickOverlay: close,
      position: "center",
      style: {
        minWidth: '70%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", { class: "closeIcon" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: close
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bannerImg" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(title.value), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ContactServicePopup, {
      ref_key: "contactRef",
      ref: contactRef
    }, null, 512),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})